import React from 'react';
import { Checkbox, Row, Col, Input, Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';

const reasonForExclude = [
  'Author / Publisher',
  'Foreign Language',
  'Low Performer (manually)',
  'Rights Already Owned',
  'Subject Matter',
  'Audio already published'
];

interface IProps {
  selectionMode: string;
  onSelectionChange: (e: RadioChangeEvent) => void;
  tags: CheckboxValueType[];
  onTagsChange: (value: CheckboxValueType[]) => void;
  isCheck: boolean;
  setIsCheck: Function;
  input: string;
  onInputChange: (e) => void;
  seriesNote: JSX.Element;
}

const BookstatExcludeOptions: React.FC<IProps> = ({
  selectionMode,
  onSelectionChange,
  tags,
  onTagsChange,
  isCheck,
  setIsCheck,
  input,
  onInputChange,
  seriesNote
}) => {
  const isSeriesMode = selectionMode === 'series';

  return (
    <div style={{ marginBottom: 12 }}>
      <Radio.Group
        value={selectionMode}
        onChange={onSelectionChange}
      >
        <Radio value='tags'>Select tag(s) for exclusion</Radio>

        <div style={{ marginTop: 12, marginLeft: 24 }}>
          <Checkbox.Group
            className='modal-menu'
            value={tags}
            onChange={onTagsChange}
            disabled={isSeriesMode}
          >
            <Row>
              {reasonForExclude.map((reason) => (
                <Col span={24} key={reason}>
                  <Checkbox value={reason}>{reason}</Checkbox>
                </Col>
              ))}

              <Col span={24}>
                <Checkbox
                  data-testid='input-checkbox'
                  checked={isCheck}
                  disabled={isSeriesMode}
                  onChange={({ target }) => {
                    setIsCheck(target.checked);
                  }}
                >
                  <Input
                    disabled={!isCheck || isSeriesMode}
                    placeholder='Enter the tag'
                    className='modal-input'
                    onChange={onInputChange}
                    value={input}
                  />
                </Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </div>

        <div style={{ marginTop: 12 }}>
          <Radio value='series'>
              Exclude an entire series
            {seriesNote}
          </Radio>
        </div>
      </Radio.Group>
    </div>
  );
};

export default BookstatExcludeOptions;
